import { ErroApi } from '../api/client'

/**
 * Traduz a falha da API para o que a tela mostra.
 *
 * O servidor já responde com texto genérico de propósito nas rotas de acesso —
 * ele não distingue "e-mail não existe" de "senha errada", e repetir aqui uma
 * distinção que lá não existe seria reintroduzir o vazamento pela interface.
 * Só os casos em que ele diz algo acionável ganham mensagem própria.
 */
export function mensagemDeErro(e: unknown, t: (chave: string) => string): string {
  if (!(e instanceof ErroApi)) return t('acesso.erroRede')

  if (e.status === 429) return t('acesso.muitasTentativas')
  if (e.status === 503) return t('acesso.emailIndisponivel')

  const corpo = e.corpo as { detail?: string } | null
  return corpo?.detail ?? t('acesso.credencialInvalida')
}
